import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { userOperations } from '../stores/user-store'
import { UserService } from '../services/user-service'
import { donePromise } from '../utils'

@Injectable({providedIn: 'root'})
export class UserActions {
  userService = new UserService();

  public loadUser(): Promise<any> {
    let p = this.userService.getUser().then(user => {
      reactor.dispatch(userOperations.setUser, user)
    })
    .catch(() => {

    })
    return donePromise(p)
  }

  agreeToTos(): Promise<any> {
    let p = this.userService.agreeToTos().then(() => {
      reactor.dispatch(userOperations.updateUser, {showTosMessage: false})
    })
    return donePromise(p)
  }
}
